import classNames from 'classnames'

import Heading from 'components/Heading'
import { sectionPadding } from 'project/padding'
import { generateSrcSet } from 'project/image-proxy-web'
import useWindowSize from 'components/util/useWindowSize'

const FeatureInHMMarketPlace = ({}) => {
  const size = useWindowSize()
  return (
    <div
      className={classNames(
        'd-flex flex-column align-items-center',
        sectionPadding,
      )}
    >
      <Heading
        size={2}
        className='fs-fluid-36-80 lh-105 fw-semibold mb-0 text-center'
      >
        Feature in the Hoxton Mix{' '}
        <span className='color-pink2'>Marketplace</span>
      </Heading>

      <div className={classNames('d-flex flex-column pt-10 pt-lg-14')}>
        <img
          {...generateSrcSet(
            size.isLgOrHigher
              ? '/images/new/au/marketplace-ui.png'
              : '/images/new/au/marketplace-ui-mobile.png',
            size.isLgOrHigher ? 1088 : 502,
            size.isLgOrHigher ? 632 : 680,
          )}
          alt='MailPortal Screenshots'
          className='img-fluid'
        />
        <div className='marketplace-ui-img-fade' />
        <div
          className={
            'd-flex flex-column fs-fluid-20-24 fw-semibold lh-140 lh-lg-114 pt-6 pt-lg-20'
          }
        >
          <span className='lh-lg-114 lh-140 fs-fluid-20-32 fw-semibold'>
            Expose your product or service to thousands of SMEs. Whether it's
            software, legal support, or business banking—join our partner
            ecosystem and deliver value to engaged Australian entrepreneurs.
          </span>
        </div>
      </div>
    </div>
  )
}

export default FeatureInHMMarketPlace
